const BaseOrganic = require('./common/base-organic');
const $ = require('cash-dom');
const QuickNav = require('./components/quick-nav');
require('../vendor/modernizr-custom.min');
const Ajax = require('./components/ajax');
const Page = require('./components/page');
const Validator = require('./components/validator');
const Device = require('./components/device');
const Template = require('./components/template');
const WriteReview = require('./components/write-review');
const SmoothScroll = require('./components/smooth-scroll');
const StarsRatingAndFeedback = require('./components/stars-rating-and-feedback');
const YoutubeEmbedEvents = require('./components/youtube-embed-events');

const VendorPage = {
  stickyEnabled: false,

  initSingleReview: function () {
    const self = this;

    //helpful link
    $(document).on('click', '.review-helpful-link:not(.loading)', function (e) {
      var $btn = $(this),
        review_id = $btn.closest('.single-user-review').attr('data-review');

      Page.startLoad('helpful', $btn);
      Ajax.post(ajaxurl, {
        action: 'UserReview_vote',
        type: 'helpful',
        review_id: review_id,
        remove: $btn.hasClass('clicked')
      }, function (response) {
        Page.finishLoad('helpful');

        if (response.success) {
          if (response.status) {
            $btn.addClass('clicked');

            $btn.find('.counter')
              .toggleClass('zero', !(response.status.helpful > 0))
              .text(response.status.helpful - 0);
          }

          $btn.toggleClass('clicked', response.status.type === 'helpful');

          if (response.status.helpful > 0) {
            setTimeout(function () {
              $btn.closest('.single-user-review').find('.review-share-link').trigger('click');
            }, 1000);
          }

        }
      }, 'json');
    });

    //share popup
    $(document).on('click', '.review-share-link', function (e) {
      e.preventDefault();

      var href = $(this).data('share-href');
      Template.popup('#review-share-popup', []);

      // setting urls the selected review
      $('#cboxLoadedContent').find('.sharrre[data-url]').attr('data-url', href);
    });

    //reply popup
    $(document).on('click', '.review-reply-link', function (e) {
      e.preventDefault();

      var vars = {};
      vars.review_id = $(this).attr('data-review');
      vars.reply_id = typeof $(this).attr('data-reply') !== 'undefined' ? $(this).attr('data-reply') : 0;
      vars.name = $(this).attr('data-author').trim();

      if (vars.review_id > 0) {
        Template.popup('#user_review_reply_form', vars, {'className': 'review-reply-popup template-popup'});
      }
    });

    //submit reply form
    $(document).on('click', 'form.add-reply .add-reply-btn', function (e) {
      e.preventDefault();

      var form = $(this).closest('form'),
        response = form.find('.server-response');

      Page.startLoad('reply-popup', 'popup');

      Ajax.post(ajaxurl, new FormData(form.get(0)), function (res) {
        Page.finishLoad('reply-popup');

        response.html('');

        if (typeof res.errors !== 'undefined' && res.errors.length > 0) {
          Validator.validate(form, res.errors, false);
        } else {
          Validator.removeErrors(form);
          form.get(0).reset();
          response.append('<div class="alert alert-success">' + res.msg + '</div>');
        }
      }, 'json');
    });
  },
  initSubmittedReview: function () {
    if ($('#ask_to_share').length) {
      setTimeout(function () {
        Template.popup('#ask_to_share', []);
      }, 2000);
    }
  },
  filterReviews: function (href, doNotUpdateHistory) {
    if (typeof href !== 'undefined') {
      if (Modernizr.history && doNotUpdateHistory !== true) {
        window.history.pushState(null, $('title').html(), href);
      }

      Ajax.post(href, {ajaxReviews: 1}, function (html) {
        $('.users-reviews-container').html(html);

        Page.scrollTo($('.users-reviews-container'), 500, -20);

        Page.finishLoad('reviews-filter');
      });
    }
  },
  initMobileScrollbox: function () {
    let scrollbox = $('#mobile_scrollbox');

    if (!scrollbox.length) {
      return;
    }

    let hideBeforeFooter = scrollbox.hasClass('desktop-visible'),
      footerEl =  $('.site-footer').get(0);

    scrollbox.find('.close-btn').on('click', (e) => {
      $('#mobile_scrollbox').remove();
    });

    window.addEventListener('scroll', function () {
      let isShowScrollbox = $('#page_title').get(0).getBoundingClientRect().top < 0;

      if (isShowScrollbox && hideBeforeFooter) {
        isShowScrollbox = Math.floor(window.scrollY) <=
          Math.ceil(document.body.scrollHeight - document.body.offsetHeight - footerEl.offsetHeight);
      }

      if (isShowScrollbox && scrollbox.hasClass('hidden')) {
        scrollbox.removeClass('hidden');
        $('body').first().addClass('mobile-scrollbox-active');
      } else if (!isShowScrollbox && !scrollbox.hasClass('hidden')) {
        scrollbox.addClass('hidden');
        $('body').first().removeClass('mobile-scrollbox-active');
      }
    }, {passive: true});
  },
  init: function () {
    var self = this;

    self.initSingleReview();
    // self.initSubmittedReview();
    self.initMobileScrollbox();

    //Filters
    $(document).on('change', '[name="reviews-filter[language][]"]', function () {
      var href = $(this).attr('data-filter-href');

      Page.startLoad('reviews-filter', '.language-filter');

      self.filterReviews(href);
    });

    $(document).on('click', 'a.page-numbers, .sort-choices a', function (e) {
      e.preventDefault();

      var href = $(this).attr('href');

      Page.startLoad('reviews-filter', $(this));

      self.filterReviews(href);
    });

    $(document).on('click', '#show_next_page', function (e) {
      e.preventDefault();

      var href = $(this).attr('href');

      Page.startLoad('reviews-filter', $(this));

      Ajax.post(href, {ajaxReviews: 1}, function (html) {
        let userReviewsList = $(html).find('#user_reviews_list'),
          moreBtn = $(html).find('#show_next_page');

        if (userReviewsList.length) {
          let userReviews = userReviewsList.find('.single-user-review');

          if (userReviews.length) {
            let firstNewReviewId = $(userReviews.get(0)).attr('data-review');

            $('#show_next_page').trigger('blur');

            $('#user_reviews_list').append(userReviewsList.html());

            // Page.scrollTo($('.single-user-review[data-review="' + firstNewReviewId + '"]'), 500, -20);
          }
        }

        if (moreBtn.length) {
          $('#show_next_page').attr('href', moreBtn.attr('href'));
        } else {
          $('.user-reviews-holder .card-footer').remove();
        }

        Page.finishLoad('reviews-filter');
      });
    });

    $(document).on('click', '#toggle_language_filter', function (e) {
      e.preventDefault();

      $('.language-filter').toggleClass('opened');
    });

    $(document).on('click', '.filter-sort-toggle', function (e) {
      e.preventDefault();
      $(this).closest('.sort-filter').toggleClass('active');
    });

    //comparisons in expert review
    $('.comparison-toggle').on('click', function (e) {
      e.preventDefault();

      var $section = $(this).closest('.section');

      $section.find('.comparison').toggleClass('d-none');
      $section.find('.bar').each(function () {
        var width = $(this).data('width');
        $(this).width(width);
      });
      $(this).find('i').toggleClass('fa-chevron-up');
    });

    $('.score-entry a').on('click', function (e) {
      e.preventDefault();

      var section = $(this).find('.score-label').text();
      var $h3 = $('h3').filter(function (i, el) {
        return $(el).text().toUpperCase().indexOf(section.toUpperCase()) >= 0;
      });

      if ($h3.length > 0) {
        Page.scrollTo($h3, 0);
      }
    });

    //selected review
    $('.selected-review').each(function () {
      this.scrollIntoView();

      var $reviewEl = $(this);
      $reviewEl.addClass('selected-review-loaded');

      setTimeout(function () {
        $reviewEl.removeClass('selected-review-loaded');
      }, 1000);
    });

    //init expert review navbar
    if ($('.expert-review').length > 0) {
      window.addEventListener('scroll', function () {
        var reviewBottom = $('.expert-review').offset().top + $('.expert-review').outerHeight() - 60,
          reviewTop = $('.expert-review').offset().top,
          scrollTop = document.documentElement.scrollTop;

        if (Device.isMobile() || Device.isTablet()) {
          if ((reviewTop > scrollTop || reviewBottom < scrollTop) && !$('#expert_review_nav').hasClass('hidden')) {
            $('#expert_review_nav').addClass('hidden');
            $('aside .sticky').removeClass('margin-top');
          }
          return;
        }

        if ($('#expert_review_nav').hasClass('hidden') && reviewTop < scrollTop && reviewBottom > scrollTop) {
          $('#expert_review_nav').removeClass('hidden');
          //add margin to sticky sidebar
          $('aside .sticky.is_stuck').addClass('margin-top');
        }

        if ((reviewTop > scrollTop || reviewBottom < scrollTop) && !$('#expert_review_nav').hasClass('hidden')) {
          $('#expert_review_nav').addClass('hidden');
          $('aside .sticky').removeClass('margin-top');
        }
      }, {passive: true});
    }

    if ($('#inactive-notification').length > 0) {
      Template.popup('#inactive-notification', {}, {'className': 'inactive-notification-popup'});
    }
  }
};

$(function () {
  BaseOrganic.init();
  QuickNav.init();
  VendorPage.init();
  WriteReview.init();
  StarsRatingAndFeedback.init();
  SmoothScroll.init();
  YoutubeEmbedEvents.init();
});
